import * as Sentry from "@sentry/vue";
import { captureException as otelCaptureException } from "@superagi/otel-error-logger-js";

class SentryService {
  captureError(error, context = {}) {
    if (process.env.NODE_ENV !== "production") {
      console.error("SentryService (dev):", error, context);
      return;
    }

    Sentry.captureException(error, {
      tags: context.tags || {},
      extra: context.extra || {},
      level: context.level || "error",
    });

    otelCaptureException(error, {
      tags: context.tags || {},
      extra: context.extra || {},
    });
  }
}

export default new SentryService();
